import Vue from 'vue'
import domUtils from 'util/dom-utils'

import withRender from './menu-list.html'
import './menu.scss'

export interface IMenuListItem {
  name: string
  iconName?: string
  disabled?: boolean
  title?: string
}

const VALID_ALIGNMENTS = ['left', 'center', 'right']

export default withRender((Vue as any).extend({
  name: 'MenuList',
  data() {
    return {
      listenerElem: undefined,
      selectedItemIndex: -1
    }
  },
  props: {
    alignMenu: {
      type: String,
      default: 'center',
      validator: value => VALID_ALIGNMENTS.indexOf(value) > -1
    },
    menuItems: Array,
    type: { // 'action' or 'dropdown'
      type: String,
      default: 'action'
    }
  },
  inject: {
    // The modal.ts "provides" this value if this menu list is inside a modal, otherwise false.
    // Need to know when inside of a modal to be able to properly close when clicking outside of
    // this menu-list
    isInModal: { default: false }
  },
  computed: {
    alignClass() {
      return [`tt-o-menu__list--align-${this.alignMenu}`]
    },
    isMenuExpanded() {
      return this.$parent.isMenuExpanded
    },
    menuItemTypeClass() {
      return `tt-o-menu__item--${this.type}`
    }
  },
  methods: {
    close() {
      this.$parent.close()
    },
    getMenuItems() {
      return this.$slots.default.filter((v) => {
        const inst = v.componentInstance
        return inst && inst.$options.name === 'MenuItem'
      })
    },
    handleTab(e) {
      e.shiftKey ? this.moveUp() : this.moveDown()
    },
    menuItemSelected(index) {
      const item = this.menuItems[index]
      if (!item.disabled) {
        this.$emit('menuItemSelected', item)
        this.close()
      }
    },
    moveDown() {
      if (this.selectedItemIndex > -1 && this.selectedItemIndex < this.menuItems.length - 1) {
        this.selectedItemIndex += 1
      } else {
        this.selectedItemIndex = 0
      }
    },
    moveUp() {
      if (this.selectedItemIndex <= 0) {
        this.selectedItemIndex = this.menuItems.length - 1
      } else {
        this.selectedItemIndex -= 1
      }
    },
    outsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.close()
      }
    },
    setItemFocus() {
      if (this.selectedItemIndex > -1 && this.selectedItemIndex < this.menuItems.length) {
        this.$el.querySelectorAll('.tt-o-menu__item')[this.selectedItemIndex].focus()
      }
    },
    setSelectedMenuItem() {
      this.getMenuItems().forEach((item, i) => {
        if (this.selectedItemIndex === i) {
          item.componentInstance.setSelected(true)
        } else {
          item.componentInstance.setSelected(false)
        }
      })
    }
  },
  watch: {
    isMenuExpanded() {
      this.selectedItemIndex = -1
      this.listenerElem = this.isInModal ? document.querySelector('.tt-o-modal') : document.body
      if (!this.listenerElem) {
        return
      }
      if (this.isMenuExpanded) {
        // due to a timing issue, if not rendered yet, need to wait by using safeFocus
        domUtils.focus(this.$el).then(() => {
          this.listenerElem.addEventListener('click', this.outsideClick, false)
        })
      } else {
        this.listenerElem.removeEventListener('click', this.outsideClick, false)
      }
    },
    selectedItemIndex() {
      this.setItemFocus()
    }
  },
  beforeDestroy() {
    // just to be sure we don't leave the event around
    if (this.listenerElem) {
      this.listenerElem.removeEventListener('click', this.outsideClick, false)
    }
  }
}))
